import { AbstractEntityEditor } from "../edit"; 
import { IDocument, IPage } from "./IDocument";
import { IPageEditable } from "./IPageEditable";

export abstract class AbstractPageEditor<TDocument extends IDocument<TPage>, TPage extends IPage> extends AbstractEntityEditor<TDocument, TPage, TPage> implements IPageEditable {
  constructor(source: TPage | AbstractPageEditor<TDocument, TPage>, isNew: boolean = false) {
    super(source, isNew);
    this._isSelected = ((source instanceof AbstractPageEditor) && source._isSelected)
      || isNew;
  }

  private _isSelected: boolean;

  isSelected(): boolean {
    return this._isSelected;
  }

  select(): void {
    this._isSelected = true;
  }

  deselect(): void {
    this._isSelected = false;
  }
}
